import { gql } from "@apollo/client";
import { useRecommendationsMockData } from "@src/features/recommendations/RecommendationsMockDataContext";
import { useGuestFeedbackSetupStatusQuery } from "./useGuestFeedbackSetupStatus.generated";

type GuestFeedbackSetupStatus = {
  loading: boolean;
  hasAnyDataSource: boolean;
  hasAnyReviews: boolean;
};

function useGuestFeedbackSetupStatus(
  options: { pollInterval?: number } = {},
): GuestFeedbackSetupStatus {
  const { useMockData } = useRecommendationsMockData();
  const { data, loading } = useGuestFeedbackSetupStatusQuery({
    skip: useMockData,
    pollInterval: options.pollInterval,
  });

  if (useMockData) {
    return { loading: false, hasAnyDataSource: true, hasAnyReviews: true };
  }

  if (!data) {
    return { loading, hasAnyDataSource: true, hasAnyReviews: true };
  }

  const hasAnyReviews = data.GuestFeedbacks.totalCount > 0;
  const hasAnyDataSource =
    hasAnyReviews ||
    data.OrgGuestFeedbackIntegrations.length > 0 ||
    data.OrgGuestFeedbackCsvUploads.totalCount > 0;

  return { loading: false, hasAnyDataSource, hasAnyReviews };
}

export default useGuestFeedbackSetupStatus;

gql`
  query GuestFeedbackSetupStatus {
    GuestFeedbacks(input: {}, pagination: { limit: 1 }) {
      totalCount
    }
    OrgGuestFeedbackIntegrations {
      id
    }
    OrgGuestFeedbackCsvUploads {
      totalCount
    }
  }
`;
